import { render } from "./AdmProfileMng.vue?vue&type=template&id=ec7dfab4&scoped=true"
import script from "./AdmProfileMng.vue?vue&type=script&lang=js"
export * from "./AdmProfileMng.vue?vue&type=script&lang=js"

import "./AdmProfileMng.vue?vue&type=style&index=0&id=ec7dfab4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec7dfab4"]])

export default __exports__